const ListAndDetailsPanel = ({
    list,
    details,
    emptyDetails = null,
    className = "",
    listClassName = "w-1/3 min-w-0",
    detailsClassName = "min-w-0 flex-1",
}) => {
    return (
        <div className={`flex min-h-0 h-full w-full gap-3 overflow-hidden ${className}`}>
            <section className={`min-h-0 overflow-hidden ${listClassName}`}>
                {list}
            </section>
            <section className={`min-h-0 overflow-hidden ${detailsClassName}`}>
                {details || emptyDetails}
            </section>
        </div>
    );
};

export default ListAndDetailsPanel;
